<template>
    <div class="container">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text-bold h3">Ingrese el monto a facturar</span>
            </div>

            <form @submit.prevent="onSubmit">
                <div class="form-group text-left">
                    <label>Monto a facturar ($ RD)</label>

                    <input
                        type="number"
                        v-model="amount"
                        class="form-control"
                        placeholder="Escriba el monto a facturar..."
                        v-validate="'required'"
                        autocomplete="off"
                        required
                    />
                </div>

                <div class="text-right">
                    <el-button
                        type="primary"
                        @click="onSubmit"
                        :icon="isLoading ? 'el-icon-loading' : ''"
                    >
                        Continuar
                    </el-button>
                </div>
            </form>
        </el-card>
    </div>
</template>

<script>
import { OrderStore } from "../OrderStore";
import router from "../router";

export default {
    name: "AmountSection",
    props: {
        msg: String,
    },
    data() {
        return {
            isLoading: false,
            amount: "",
        };
    },
    methods: {
        async onSubmit() {
            // On employee code submit
            if (this.amount === "") {
                return this.$notify({
                    title: "Error",
                    message: "Debe ingresar un monto",
                    type: "error",
                });
            }

            if (this.amount === "0") {
                return this.$notify({
                    title: "Error",
                    message: "El monto no puede ser 0",
                    type: "error",
                });
            }

            if (this.amount < 0) {
                return this.$notify({
                    title: "Error",
                    message: "El monto no puede ser menor que 0",
                    type: "error",
                });
            }

            if (this.isLoading) {
                return this.$notify({
                    title: "Loading",
                    message: "Cargando...",
                    type: "info",
                });
            }

            const orderValue = this.formatOnTwoDecimals(this.amount);

            OrderStore.Amount = orderValue;

            router.push("/employee");
            this.amount = "";
        },

        formatOnTwoDecimals(value) {
            return (Math.round(value * 100) / 100).toFixed(2);
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
    margin: 40px 0 0;
}
ul {
    list-style-type: none;
    padding: 0;
}
li {
    display: inline-block;
    margin: 0 10px;
}
a {
    color: #42b983;
}

.container {
    margin-top: 50px;
}
</style>
